import React, { Component } from "react"
import PropTypes from "prop-types"

class NewsletterModal extends Component {
  constructor(props) {
    super(props)
    this.state = props
  }

  getValue = () => {
    return {
      type: "newsletter-modal-component",
      props: this.state,
    }
  }

  validate = () => {
    if (!this.state.title) {
      return false
    } else {
      return true
    }
  }

  handelInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  render() {
    let { title, description, delay } = this.state
    return (
      <section className="csm-component">
        <h3 className="cms-component--title">Newsletter Modal</h3>
        <div className="form-group">
          <label htmlFor="newsletter-modal--title">Title</label>
          <input
            id="newsletter-modal--title"
            type="text"
            name="title"
            value={title}
            className={`form-control input-outline`}
            placeholder="Title"
            aria-describedby="user-email"
            onChange={this.handelInputChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="newsletter-modal--description">Description</label>
          <textarea
            type="text"
            name="description"
            value={description}
            className={`form-control input-outline`}
            placeholder="Description"
            aria-describedby="user-email"
            onChange={this.handelInputChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="newsletter-modal--delay">Delay</label>
          <input
            type="number"
            name="delay"
            value={delay}
            className={`form-control input-outline`}
            placeholder="Modal delay"
            aria-describedby="user-email"
            onChange={this.handelInputChange}
          />
          <small id="delayhelp" className="form-text text-muted">
            How long will it take for the modal to show, in seconds.
          </small>
        </div>
      </section>
    )
  }
}

NewsletterModal.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  delay: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

NewsletterModal.defaultProps = {
  title: "",
  description: "",
  delay: 4,
}

export default NewsletterModal
